"use client";

import React from "react";
import { Check, X, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function OurGuidingPhilosophy() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const institutionalPoints = ["Standardized Model Portfolios", "Call Center Support", "Reactive Quarterly Reviews", "Hidden Fee Structures", "Volume-Driven Sales Quotas", "Generalist Advice"];
  const cyradonPoints = ["Bespoke Wealth Architecture", "Direct Partner Access", "Proactive Tax & Estate Strategy", "Fiduciary Transparency", "Relationship-Driven Service", "Specialized Regional Expertise"];
  return <section id="our-guiding-philosophy" ref={ref} className="dark bg-background text-foreground py-24 lg:py-32 overflow-hidden relative">
      <div className="container mx-auto px-6 md:px-12">
        <div className={cn("grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {}
          <div className="flex flex-col space-y-8 lg:text-right order-2 lg:order-1">
            <div className="space-y-4">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-muted-foreground line-through decoration-muted-foreground/50 decoration-2">
                The Institutional Approach
              </h2>
              <p className="text-muted-foreground text-lg md:text-xl max-w-md ml-auto">
                Large firms often prioritize scale over specificity, offering
                pre-packaged solutions that fail to address complex needs.
              </p>
            </div>

            <ul className="space-y-6">
              {institutionalPoints.map((point, i) => <li key={i} data-index={i} className="flex items-center justify-start lg:justify-end gap-4 text-muted-foreground/60 group">
                  <span className="text-lg md:text-xl font-light line-through decoration-muted-foreground/40 transition-colors group-hover:text-muted-foreground/80">
                    {point}
                  </span>
                  <X className="w-5 h-5 text-muted-foreground/40 shrink-0" />
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col space-y-8 order-1 lg:order-2 relative">
            {}
            <div className="hidden lg:block absolute -left-12 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-border to-transparent" />

            <div className="space-y-4">
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-secondary font-bold tracking-tight">
                The Cyradon Standard
              </h2>
              <p className="text-foreground/90 text-lg md:text-xl max-w-md">
                We believe true wealth management requires a personal architect,
                not just an account manager.
              </p>
            </div>

            <ul className="space-y-6">
              {cyradonPoints.map((point, i) => <li key={i} data-index={i} className="flex items-center gap-4 text-foreground group">
                  <div className="flex items-center justify-center w-6 h-6 rounded-full bg-secondary/10 text-secondary shrink-0">
                    <Check className="w-4 h-4" />
                  </div>
                  <span className="text-xl md:text-2xl font-medium text-foreground group-hover:text-secondary transition-colors duration-300">
                    {point}
                  </span>
                </li>)}
            </ul>

            <div className="pt-8">
              <Button asChild size="lg" className="bg-secondary text-secondary-foreground hover:bg-secondary/90 text-lg px-8 h-14 rounded-full">
                <Link to="/WealthArchitecturePage">
                  Experience the Difference <ArrowRight className="ml-2 w-5 h-5" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}